import React, { Component } from "react";
import MUIDataTable from "mui-datatables";
import {
  createMuiTheme,
  MuiThemeProvider,
  withStyles
} from "@material-ui/core/styles";
import api from "../common/api";
import axios from "axios";
import { Container, Row, Col } from "shards-react";
import Typography from "@material-ui/core/Typography";
import PageTitle from "../common/PageTitle";
import Fab from "@material-ui/core/Fab";
import EditIcon from "@material-ui/icons/Edit";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import Charts from "./../../views/charts";
import colors from "./../../utils/colors";
import CircularProgress from "@material-ui/core/CircularProgress";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import AddIcon from "@material-ui/icons/Add";
import GroupAddIcon from "@material-ui/icons/GroupAdd";
import TextField from "@material-ui/core/TextField";
import EventIcon from "@material-ui/icons/Event";
import Switch from "@material-ui/core/Switch";
import PublishIcon from "@material-ui/icons/Publish";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Grow from "@material-ui/core/Grow";
import Paper from "@material-ui/core/Paper";
import Popper from "@material-ui/core/Popper";
import MenuItem from "@material-ui/core/MenuItem";
import MenuList from "@material-ui/core/MenuList";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import Backdrop from "@material-ui/core/Backdrop";

import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import InputAdornment from "@material-ui/core/InputAdornment";

import FormControlLabel from "@material-ui/core/FormControlLabel";
import { FavoriteBorder } from "@material-ui/icons";
import SearchIcon from "@material-ui/icons/Search";

const useStyles = theme => ({
  menu: {
    fontSize: "0.75rem"
  }
});

function groupBy(data, key) {
  return data.reduce((acc, x) => {
    acc[x[key]] = [...(acc[x[key]] || []), x];
    return acc;
  }, {});
}

function length(data, labels, total) {
  var acc = [];
  labels.map((val, idx) => {
    var percentage = data[val].length;
    percentage = Math.ceil(percentage);
    //		percentage = String(percentage) + '%'
    percentage = String(percentage);
    //		percentage.concat('%')
    acc.push(percentage);
  });
  return acc;
}

class OT extends React.Component {
  constructor() {
    super();

    this.state = {
      display: "d-none",
      loaded: false,
      refreshing: false,
      backdrop: false,
      work_orders: [{}],
      closed: false,
      mine: true,
      work_orders_new: false,
      attention_required: false,
      waiting_answer: false,
      download_menu_open: false,
      serverSide: true,
      users: [],
      dialog: { open: false, work_orders: [], message: "", saving: false },
      filters: [],
      count: 0,
      q_rows: 100,
      work_order_types: [],
      work_order_states: [],
      userConfigTableState: {
        //Dynamic collection of props that are needed between table refreshes.
        searchText: "",
        filterList: [],
        columns: []
      }
    };
    this.handleChartsClose = this.handleChartsClose.bind(this);
    this.handleChartsOpen = this.handleChartsOpen.bind(this);
  }

  async componentDidMount() {
    const searchParams = new URLSearchParams(window.location.search);
    var closed = this.state.closed;
    var mine = this.state.mine;
    await this.getUsers();
    await this.getDropdowns();
    await this.getUserConfig(closed, mine);
    this.setState({ plate: searchParams.get("plate") });
  }

  getUsers = () => {
    const token = localStorage.getItem("userToken");
    return axios
      .get(api.users().index(), {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        this.setState({ users: res.data });
      })
      .catch(err => {
        this.setState({ users: [] });
      });
  };
  getDropdowns = async () => {
    let self = this;
    const token = localStorage.getItem("userToken");
    await axios
      .get(api.dropdowns().ot(), {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`
        }
      })
      .then(response => {
        var res = response.data;
        var work_order_types = res.work_order_types.map(function(item) {
          return item["name"];
        });
        var work_order_states = Object.values(res.work_order_type_places);
        var work_order_origins = res.work_order_origins.map(function(item) {
          return item["name"];
        });
        this.setState({
          work_order_types: work_order_types,
          work_order_origins: work_order_origins,
          work_order_states: work_order_states
        });
      })
      .catch(function(error) {
        console.log(error);
      });
  };

  getUserConfig = async (closed, mine) => {
    const token = localStorage.getItem("userToken");
    await axios
      .get(api.users().getConfig("work_orders"), {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        var user_config = res.data[0];
        if (user_config.value) {
          user_config.value = JSON.parse(user_config.value);
          this.setState({ userConfigTableState: user_config.value });
          closed = user_config.value.closed ? user_config.value.closed : closed;
          mine =
            user_config.value.mine !== undefined
              ? user_config.value.mine
              : mine;
          this.setState({ closed: closed, mine: mine });
        }
      })
      .catch(err => {
        console.log(err);
      });
    this.getWorkOrders(closed, mine);
  };

  getWorkOrders = async (closed, mine, page = 1) => {
    this.setState({ refreshing: true });
    closed = closed ? 1 : 0;
    mine = mine ? 1 : 0;
    var columns = this.state.userConfigTableState.columns.map((c, id) => {
      return {
        name: c.name,
        filterList: c.filterList,
        sortDirection: c.sortDirection,
        sort: c.sort
      };
    });
    var params = {
      columns: JSON.stringify(columns),
      q_rows: this.state.q_rows,
      page: page,
      searchText: this.state.userConfigTableState.searchText
    };
    const token = localStorage.getItem("userToken");
    const searchParams = new URLSearchParams(window.location.search);
    const id = searchParams.get("id");
    if (id) params = {};
    await axios
      .get(api.work_order().index(closed, mine, id ? id : ""), {
        headers: { Authorization: `Bearer ${token}` },
        params: params
      })
      .then(res => {
        var response = res.data;
        var work_orders = response.data;
        this.setState({
          work_orders: work_orders,
          loaded: true,
          count: response.meta.total,
          refreshing: false
        });
      })
      .catch(err => {
        console.log(err);
      });
  };

  handleChartsClose() {
    this.setState({ display: "d-none" });
  }

  handleChartsOpen() {
    this.setState({ display: "" });
  }

  handleClosedWorkOrders = () => {
    var closed = !this.state.closed;
    this.setState({ closed: closed, loaded: false, work_orders: [{}] });
    this.getWorkOrders(closed, this.state.mine);
  };

  handleMyWorkOrders = () => {
    var mine = !this.state.mine;
    this.setState({ mine: mine, loaded: false, work_orders: [{}] });
    this.getWorkOrders(this.state.closed, mine);
  };

  handleFilterSubmit = filterList => {
    var userConfigTableState = this.state.userConfigTableState;
    filterList.forEach((element, index) => {
      userConfigTableState.columns[index].filterList = element;
    });
    userConfigTableState.filterList = filterList;
    this.setState(
      { loaded: false, userConfigTableState: userConfigTableState },
      () => {
        this.getWorkOrders(this.state.closed, this.state.mine);
      }
    );
  };

  handleDownloadMenu = e => {
    var download_menu_open = this.state.download_menu_open;
    this.setState({ download_menu_open: !download_menu_open });
  };

  handleDownload = (e, grouped, vouchers) => {
    this.setState({ backdrop: true });
    const token = localStorage.getItem("userToken");
    var formData = new FormData();
    formData.set("grouped", grouped);
    formData.set("vouchers", vouchers);
    formData.set("closed", this.state.closed);
    formData.set("mine", this.state.mine);
    formData.set(
      "columns",
      JSON.stringify(this.state.userConfigTableState.columns)
    );

    axios
      .post(api.work_order().export(), formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`
        }
      })
      .then(response => {
        this.handleCloseBackdrop();
        window.location.href = response.data;
      })
      .catch(error => {
        alert("Falló la descarga");
      });
  };

  handleDownloadUserAlert = () => {
    this.setState({ backdrop: true });
    const token = localStorage.getItem("userToken");
    axios
      .get(api.work_order_alerts().export(""), {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`
        }
      })
      .then(response => {
        this.handleCloseBackdrop();
        window.location.href = response.data;
      })
      .catch(error => {
        alert("Falló la descarga");
      });
  };

  handleDownloadVehicleMovement = () => {
    this.setState({ backdrop: true });
    const token = localStorage.getItem("userToken");
    axios
      .get(api.vehicle_movements().export(""), {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`
        }
      })
      .then(response => {
        this.handleCloseBackdrop();
        window.location.href = response.data;
      })
      .catch(error => {
        alert("Falló la descarga");
      });
  };

  handleDownloadValets = () => {
    this.setState({ backdrop: true });
    const token = localStorage.getItem("userToken");
    var formData = new FormData();
    formData.set("valet", 1);
    formData.set("vouchers", 0);
    formData.set("closed", 0);
    formData.set("mine", 0);
    axios
      .post(api.work_order().export(), formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`
        }
      })
      .then(response => {
        this.handleCloseBackdrop();
        window.location.href = response.data;
      })
      .catch(error => {
        alert("Falló la descarga");
      });
  };

  handleCloseBackdrop = () => {
    var backdrop = !this.state.backdrop;
    this.setState({ backdrop: backdrop });
  };

  getMuiTheme = () =>
    createMuiTheme({
      overrides: {
        MuiTableCell: {
          root: {
            padding: "0px 8px 0px 8px",
            fontSize: "0.73rem"
          },

          MuiInputLabel: {
            root: {
              fontSize: "0.70rem",
              color: "red"
            }
          }
        },
        MuiFormControlLabel: {
          root: {
            maxWidth: "70px",
            textAlign: "center"
          }
        },
        MUIDataTableToolbar: {
          root: {
            minHeight: "0px"
          }
        },
        MuiTableFooter: {
          root: {
            fontSize: "0.73rem"
          }
        },
        MuiTypography: {
          body2: {
            fontSize: "0.73rem"
          }
        },
        MuiTablePagination: {
          toolbar: {
            minHeight: "0px"
          }
        },
        MuiIconButton: {
          root: {
            padding: "4px"
          }
        },
        MUIDataTableHeadCell: {
          fixedHeader: {
            fontSize: "0.875rem"
          }
        },
        MuiFormLabel: {
          root: {
            fontSize: "0.75rem"
          }
        },
        MuiInputBase: {
          root: {
            fontSize: "0.75rem"
          }
        },
        MuiTypography: {
          body1: {
            fontSize: "0.75rem"
          }
        },
        MUIDataTableViewCol: {
          label: {
            fontSize: "0.75rem"
          }
        }
      }
    });

  handleAssignWorkOrders = (rows, data) => {
    var rows_ids = [];
    rows.data.map((val, idx) => {
      rows_ids.push(val.dataIndex);
    });
    var work_orders = data.filter(item => rows_ids.includes(item.dataIndex));
    if (work_orders.length > 0) {
      var dialog = this.state.dialog;
      dialog.work_orders = work_orders;
      dialog.submit = 0;
      dialog.message = "";
      this.setState({ dialog: dialog });
      this.handleAssignWorkOrderDialog();
    }
  };

  handleAssignWorkOrderDialog = () => {
    var dialog = this.state.dialog;
    dialog.open = !dialog.open;
    dialog.submit = 0;
    this.setState({ dialog: dialog });
  };

  handleAssignWorkOrderSubmit = () => {
    var dialog = this.state.dialog;
    dialog.saving = true;
    this.setState({ dialog: dialog });
    var formData = new FormData();
    var i = 0;
    var work_orders = this.state.dialog.work_orders.map((val, idx) => {
      formData.set("work_order[" + i + "][id]", val.data[0]);
      formData.set("work_order[" + i + "][user_id]", this.state.dialog.user_id);
      i++;
    });
    let self = this;
    const token = localStorage.getItem("userToken");
    var dialog = this.state.dialog;
    axios
      .post(api.work_order().assign(), formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`
        }
      })
      .then(response => {
        dialog.title = "Orden de trabajo";
        dialog.success = 1;
        dialog.submit = 1;
        dialog.saving = false;
        dialog.open = true;
        dialog.message = "Se han asignado las OT con éxito!";
        dialog.work_orders = [];
        self.setState({ dialog: dialog });
        var closed = self.state.closed;
        var mine = self.state.mine;
        self.getWorkOrders(closed, mine);
      })
      .catch(error => {
        dialog.title = "Orden de trabajo";
        dialog.message = "Ha ocurrido un error!";
        dialog.open = true;
        dialog.saving = false;
        dialog.success = 0;
        dialog.submit = 1;
        dialog.work_orders = [];
        self.setState({ dialog: dialog });
      });
  };

  handleAssignUserChange = e => {
    var dialog = this.state.dialog;
    dialog.user_id = e.target.value;
    this.setState({ dialog: dialog });
  };

  handleAutoFilter = (key, value) => {
    var filters = this.state.filters;
    if (key === "work_orders_new") {
      var work_orders_new = value.target.checked;
      filters["state"] = ["ingresada"];
      if (!work_orders_new) {
        filters["state"] = [];
      }
      this.setState({
        work_orders_new: work_orders_new,
        waiting_answer: false,
        attention_required: false
      });
    }
    if (key === "waiting_answer") {
      var waiting_answer = value.target.checked;
      filters["state"] = [
        "pendiente_aprobacion",
        "presentar_factura",
        "respuesta_mobile"
      ];
      if (!waiting_answer) {
        filters["state"] = [];
      }
      this.setState({
        waiting_answer: waiting_answer,
        work_orders_new: false,
        attention_required: false
      });
    }
    if (key === "attention_required") {
      var attention_required = value.target.checked;
      filters["state"] = [
        "aprobada",
        "presupuestada",
        "pendiente_presupuestar"
      ];
      if (!attention_required) {
        filters["state"] = [];
      }
      this.setState({
        attention_required: attention_required,
        work_orders_new: false,
        waiting_answer: false
      });
    }
    var userConfigTableState = this.state.userConfigTableState;
    var colIndex = userConfigTableState.columns.findIndex(
      col => col.name == "state"
    );
    userConfigTableState.columns[colIndex].filterList = filters["state"];
    this.setState({
      userConfigTableState: userConfigTableState,
      loaded: false
    });
    this.getWorkOrders(this.state.closed, this.state.mine);

    //this.setState({filters: filters})
  };

  handleSaveFilters = () => {
    var formData = new FormData();
    var i = 0;
    formData.set("name", "work_orders");
    formData.set("key", "work_orders");
    var config = this.state.userConfigTableState;
    config.mine = this.state.mine ? 1 : 0;
    config.closed = this.state.closed ? 1 : 0;
    config.data = [];
    config.displayData = [];
    formData.set("value", JSON.stringify(config));
    let self = this;
    const token = localStorage.getItem("userToken");
    var dialog = this.state.dialog;
    axios
      .post(api.users().storeConfig(), formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`
        }
      })
      .then(response => {
        dialog.title = "Orden de trabajo";
        dialog.success = 1;
        dialog.submit = 1;
        dialog.open = true;
        dialog.message = "Se han guardado los filtros con éxito!";
        dialog.work_orders = [];
        self.setState({ dialog: dialog });
      })
      .catch(error => {
        dialog.title = "Orden de trabajo";
        dialog.message = "Ha ocurrido un error!";
        dialog.open = true;
        dialog.success = 0;
        dialog.submit = 1;
        dialog.work_orders = [];
        self.setState({ dialog: dialog });
      });
  };

  handleChange = async (action, tableState) => {
    if (action !== "propsUpdate" && action !== "filterChange") {
      this.setState({
        userConfigTableState: {
          searchText: tableState.searchText,
          filterList: tableState.filterList,
          columns: tableState.columns
        }
      });
    }
  };
  getColumns = () => {
    //Define all of the alert table's columns and their default props and options as per the mui-datatables documentation
    var columns = [
      {
        name: "id",
        label: "#",
        options: {
          filter: true,
          filterType: "textField",
          sort: true,
          draggable: false
        }
      },
      {
        name: "contract",
        label: "Cliente",
        options: {
          filter: true,
          sort: true,
          filterType: "textField"
        }
      },
      {
        name: "vehicle.plate",
        label: "Patente",
        options: {
          filter: true,
          sort: true,
          filterType: "textField",
          filterList: this.state.plate ? [this.state.plate] : null
        }
      },
      {
        name: "type_name",
        label: "Tipo",
        options: {
          filter: true,
          sort: true,
          filterType: "multiselect",
          filterOptions: this.state.work_order_types
        }
      },

      {
        name: "updated_at",
        label: "Ult. fecha",
        options: {
          filter: true,
          sort: true,
          filterType: "custom",
          filterOptions: {
            names: [],
            logic(updated_at, filters) {
              var min = filters[0] ? new Date(filters[0]) : null;
              var max = filters[1] ? new Date(filters[1]) : null;
              var updated_at = updated_at ? updated_at.split(" ")[0] : null;
              updated_at = updated_at
                ? new Date(
                    updated_at.split("-")[2],
                    updated_at.split("-")[1] - 1,
                    updated_at.split("-")[0]
                  )
                : null;
              if (min && max) {
                return !(updated_at >= min && updated_at <= max);
              }
              return false;
            },
            display: (filterList, onChange, index, column) => (
              <div>
                <TextField
                  label="Ult. Fecha desde"
                  InputLabelProps={{
                    shrink: true
                  }}
                  type="date"
                  value={filterList[index][0] || ""}
                  onChange={event => {
                    filterList[index][0] = event.target.value;
                    onChange(filterList[index], index, column);
                  }}
                  style={{ width: "45%" }}
                />
                <TextField
                  label="Ult. Fecha hasta"
                  type="date"
                  InputLabelProps={{
                    shrink: true
                  }}
                  value={filterList[index][1] || ""}
                  onChange={event => {
                    filterList[index][1] = event.target.value;
                    onChange(filterList[index], index, column);
                  }}
                  style={{ width: "45%" }}
                />
              </div>
            )
          }
        }
      },
      {
        name: "state",
        label: "Estado",
        options: {
          filter: true,
          sort: true,
          filterType: "multiselect",
          filterOptions: this.state.work_order_states
        }
      },
      {
        name: "reason",
        label: "Motivo",
        options: {
          filter: true,
          sort: true,
          display: false,
          filterType: "textField"
        }
      },
      {
        name: "group",
        label: "Grupo empresa",
        options: {
          filter: true,
          sort: true,
          display: false,
          filterType: "multiselect"
        }
      },
      {
        name: "created_at",
        label: "Fecha creacion OT",
        options: {
          filter: true,
          sort: true,
          filterType: "custom",
          filterOptions: {
            names: [],
            logic(updated_at, filters) {
              var min = filters[0] ? new Date(filters[0]) : null;
              var max = filters[1] ? new Date(filters[1]) : null;
              var updated_at = updated_at ? updated_at.split(" ")[0] : null;
              updated_at = updated_at
                ? new Date(
                    updated_at.split("-")[2],
                    updated_at.split("-")[1] - 1,
                    updated_at.split("-")[0]
                  )
                : null;
              if (min && max) {
                return !(updated_at >= min && updated_at <= max);
              }
              return false;
            },
            display: (filterList, onChange, index, column) => (
              <div>
                <TextField
                  label="Fecha creacion desde"
                  InputLabelProps={{
                    shrink: true
                  }}
                  type="date"
                  value={filterList[index][0] || ""}
                  onChange={event => {
                    filterList[index][0] = event.target.value;
                    onChange(filterList[index], index, column);
                  }}
                  style={{ width: "45%" }}
                />
                <TextField
                  label="Fecha creacion hasta"
                  type="date"
                  InputLabelProps={{
                    shrink: true
                  }}
                  value={filterList[index][1] || ""}
                  onChange={event => {
                    filterList[index][1] = event.target.value;
                    onChange(filterList[index], index, column);
                  }}
                  style={{ width: "45%" }}
                />
              </div>
            )
          }
        }
      },
      {
        name: "km",
        label: "KM",
        options: {
          filter: false,
          sort: true,
          display: false
        }
      },
      {
        name: "vehicle.version.full_name.name",
        label: "Vehículo",
        options: {
          filter: false,
          sort: true,
          display: false,
          filterType: "dropdown"
        }
      },
      {
        name: "budgets.0.provider.business_name",
        label: "Proveedor",
        options: {
          filter: true,
          sort: true,
          display: true,
          filterType: "textField"
        }
      },
      {
        name: "budgets.0.provider.address",
        label: "Dirección Proveedor",
        options: {
          filter: false,
          sort: true,
          display: false,
          filterType: "dropdown",
          customBodyRender: (value, tableMeta, updateValue) => {
            var address = "";
            if (value !== null && value !== undefined && value !== "") {
              address = JSON.parse(value).formatted_address;
            }
            return address;
          }
        }
      },
      {
        name: "internal_code",
        label: "Cod. Interno",
        options: {
          filter: true,
          filterType: "textField",
          sort: false,
          display: false
        }
      },
      {
        name: "hansa_code",
        label: "Cod. Hansa",
        options: {
          filter: true,
          filterType: "textField",
          sort: false,
          display: false
        }
      },
      {
        name: "user.name",
        label: "Operador",
        options: {
          filter: true,
          filterType: "dropdown",
          filterOptions: this.state.users.map(function(item) {
            return item["name"];
          }),
          sort: false,
          display: false
        }
      },
      {
        name: "freshdesk_code",
        label: "# Freshdesk",
        options: {
          filter: true,
          filterType: "textField",
          sort: true,
          display: false
        }
      },
      {
        name: "voucher.hansa_code",
        label: "# Factura",
        options: {
          filter: true,
          filterType: "textField",
          sort: true,
          display: false
        }
      },
      {
        name: "origin_name",
        label: "Origen",
        options: {
          filter: true,
          sort: true,
          filterType: "multiselect",
          filterOptions: this.state.work_order_origins
        }
      },
      {
        name: "relation",
        label: "OT Relacionada",
        options: {
          filter: false,
          filterType: "dropdown",
          sort: true,
          display: false,
          viewColumns: true,
          customBodyRender: (value, tableMeta, updateValue) => {
            if (value) {
              return (
                <a href={"/work-order/" + value} target="blank">
                  {value}
                </a>
              );
            }
            return <div></div>;
          }
        }
      },
      {
        name: "voucher.created_at",
        label: "Fecha creacion factura",
        options: {
          filter: true,
          sort: true,
          filterType: "custom",
          filterOptions: {
            names: [],
            logic(updated_at, filters) {
              var min = filters[0] ? new Date(filters[0]) : null;
              var max = filters[1] ? new Date(filters[1]) : null;
              var updated_at = updated_at ? updated_at.split(" ")[0] : null;
              updated_at = updated_at
                ? new Date(
                    updated_at.split("-")[2],
                    updated_at.split("-")[1] - 1,
                    updated_at.split("-")[0]
                  )
                : null;
              if (min && max) {
                return !(updated_at >= min && updated_at <= max);
              }
              return false;
            },
            display: (filterList, onChange, index, column) => (
              <div>
                <TextField
                  label="Fecha creacion factura desde"
                  InputLabelProps={{
                    shrink: true
                  }}
                  type="date"
                  value={filterList[index][0] || ""}
                  onChange={event => {
                    filterList[index][0] = event.target.value;
                    onChange(filterList[index], index, column);
                  }}
                  style={{ width: "45%" }}
                />
                <TextField
                  label="Fecha creacion factura hasta"
                  type="date"
                  InputLabelProps={{
                    shrink: true
                  }}
                  value={filterList[index][1] || ""}
                  onChange={event => {
                    filterList[index][1] = event.target.value;
                    onChange(filterList[index], index, column);
                  }}
                  style={{ width: "45%" }}
                />
              </div>
            )
          }
        }
      },
      {
        name: "vehicle.is_fleet_owner",
        label: "Tipo de flota",
        options: {
          filter: true,
          sort: true,
          filterType: "dropdown",
          filterOptions: ["Propio", "Terceros"],
          customBodyRender: (value, tableMeta, updateValue) => {
            return value ? "Propio" : "Terceros";
          }
        }
      },
      {
        name: "close_date",
        label: "Fecha de cierre",
        options: {
          filter: true,
          sort: true,
          display: false,
          filterType: "custom",
          filterOptions: {
            names: [],
            logic(close_date, filters) {
              var min = filters[0] ? new Date(filters[0]) : null;
              var max = filters[1] ? new Date(filters[1]) : null;
              var close_date = close_date ? close_date.split(" ")[0] : null;
              close_date = close_date
                ? new Date(
                    close_date.split("-")[2],
                    close_date.split("-")[1] - 1,
                    close_date.split("-")[0]
                  )
                : null;
              if (min && max) {
                return !(close_date >= min && close_date <= max);
              }
              return false;
            },
            display: (filterList, onChange, index, column) => (
              <div>
                <TextField
                  label="Fecha cierre desde"
                  InputLabelProps={{
                    shrink: true
                  }}
                  type="date"
                  value={filterList[index][0] || ""}
                  onChange={event => {
                    filterList[index][0] = event.target.value;
                    onChange(filterList[index], index, column);
                  }}
                  style={{ width: "45%" }}
                />
                <TextField
                  label="Fecha cierre hasta"
                  type="date"
                  InputLabelProps={{
                    shrink: true
                  }}
                  value={filterList[index][1] || ""}
                  onChange={event => {
                    filterList[index][1] = event.target.value;
                    onChange(filterList[index], index, column);
                  }}
                  style={{ width: "45%" }}
                />
              </div>
            )
          }
        }
      },
      {
        name: "oc_sap_code",
        label: "OC SAP",
        options: {
          filter: false,
          sort: true,
          display: false,
          filterType: "textField"
        }
      },
      {
        name: "reception_sap_code",
        label: "Recepción SAP",
        options: {
          filter: false,
          sort: true,
          display: false,
          filterType: "textField"
        }
      },
      {
        name: "",
        label: "",
        options: {
          filter: false,
          sort: false,
          viewColumns: false,
          customBodyRender: (value, tableMeta, updateValue) => {
            return (
              <Fab
                color="primary"
                aria-label="edit"
                variant="extended"
                style={{ boxShadow: "none" }}
                fontSize="small"
                className="MuiButtonBase-root MuiFab-sizeSmall mr-2"
                href={"work-order/" + tableMeta.rowData[0]}
              >
                <EditIcon fontSize="small" />
              </Fab>
            );
          }
        }
      },
      {
        name: "layout",
        label: "layout",
        options: {
          filter: false,
          sort: false,
          display: false,
          viewColumns: false
        }
      },
      {
        name: "layout.display",
        label: "layout.display",
        options: {
          filter: false,
          sort: false,
          display: false,
          empty: true,
          viewColumns: false,
          filterList: this.state.filters["display"]
            ? [this.state.filters["display"][0]]
            : []
        }
      }
    ];
    //Loop thru columns and assign all column-specific settings that need to persist thru a data refresh
    for (let i = 0; i < columns.length; i++) {
      //Assign the filter list to persist
      if (!columns[i].options) {
        columns[i].options = columns[i];
      }
      columns[i].options.filterList = [];
      if (this.state.userConfigTableState.filterList[i]) {
        columns[
          i
        ].options.filterList = this.state.userConfigTableState.filterList[i];
      }
      columns[
        i
      ].options.filterList = this.state.userConfigTableState.filterList[i];

      if (
        this.state.userConfigTableState.columns[i] !== undefined &&
        this.state.userConfigTableState.columns[i].name === columns[i].name
      ) {
        //If 'display' has a value in userConfigTableState, assign that, or else leave it alone
        if (
          this.state.userConfigTableState.columns[i].hasOwnProperty("display")
        )
          columns[i].options.display = this.state.userConfigTableState.columns[
            i
          ].display;
        //If 'sortDirection' has a value in userConfigTableState, assign that, or else leave it alone
        if (
          this.state.userConfigTableState.columns[i].hasOwnProperty(
            "sortDirection"
          )
        ) {
          //The sortDirection prop only permits sortDirection for one column at a time
          if (
            this.state.userConfigTableState.columns[i].sortDirection != "none"
          )
            columns[
              i
            ].options.sortDirection = this.state.userConfigTableState.columns[
              i
            ].sortDirection;
        }
      }
    }

    if (this.state.filters["state"]) {
      var filters = columns[5].options.filterList;
      var filters_unified = filters.concat(this.state.filters["state"]);
      columns[5].options.filterList = filters_unified;
    }

    return columns;
  };
  render() {
    var chartstate = {};
    var charttype = {};
    var chartContract = {};
    var dialog = this.state.dialog;
    const classes = this.props.classes;
    if (this.state.loaded) {
      var chartstate = {
        labels: Object.keys(groupBy(this.state.work_orders, "state")), // ["SANOFI", "SHIRE", "Otros"],
        datasets: [
          {
            hoverBorderColor: colors.white.toRGBA(1),
            data: length(
              groupBy(this.state.work_orders, "state"),
              Object.keys(groupBy(this.state.work_orders, "state")),
              this.state.work_orders.length
            ),
            icons: [],
            backgroundColor: [
              colors.primary.toRGBA(0.9),
              colors.primary.toRGBA(0.5),
              colors.primary.toRGBA(0.3)
            ]
          }
        ]
      };
      var charttype = {
        labels: Object.keys(groupBy(this.state.work_orders, "type_name")), //[],
        datasets: [
          {
            hoverBorderColor: colors.white.toRGBA(1),
            data: length(
              groupBy(this.state.work_orders, "type_name"),
              Object.keys(groupBy(this.state.work_orders, "type_name")),
              this.state.work_orders.length
            ),
            icons: [],
            backgroundColor: [
              colors.primary.toRGBA(0.9),
              colors.primary.toRGBA(0.5),
              colors.primary.toRGBA(0.3)
            ]
          }
        ]
      };
      var chartContract = {
        labels: Object.keys(groupBy(this.state.work_orders, "contract")), //[],
        datasets: [
          {
            hoverBorderColor: colors.white.toRGBA(1),
            data: length(
              groupBy(this.state.work_orders, "contract"),
              Object.keys(groupBy(this.state.work_orders, "contract")),
              this.state.work_orders.length
            ),
            icons: [],
            backgroundColor: [
              colors.primary.toRGBA(0.9),
              colors.primary.toRGBA(0.5),
              colors.primary.toRGBA(0.3)
            ]
          }
        ]
      };
    }

    const options = {
      customToolbar: () => {
        return (
          <React.Fragment>
            <Tooltip title={"Guardar filtros"}>
              <IconButton
                onClick={e => {
                  this.handleSaveFilters(e);
                }}
              >
                <FavoriteBorder />
              </IconButton>
            </Tooltip>
            <Tooltip title={"Importar"}>
              <IconButton
                onClick={e => {
                  window.location.href = "work-orders/import";
                }}
              >
                <PublishIcon />
              </IconButton>
            </Tooltip>

            <Tooltip title={"Descargar"}>
              <IconButton
                onClick={e => {
                  this.handleDownloadMenu(e);
                }}
              >
                <CloudDownloadIcon />
                <Popper
                  open={this.state.download_menu_open}
                  anchorEl={this.state.download_menu_open}
                  role={undefined}
                  transition
                  disablePortal
                  style={{ zIndex: 1000 }}
                >
                  {({ TransitionProps, placement }) => (
                    <Grow
                      {...TransitionProps}
                      style={{
                        transformOrigin:
                          placement === "bottom"
                            ? "center top"
                            : "center bottom"
                      }}
                    >
                      <Paper>
                        <ClickAwayListener
                          onClickAway={e => {
                            this.handleDownloadMenu(e);
                          }}
                        >
                          <MenuList
                            autoFocusItem={this.state.download_menu_open}
                            id="menu-list-grow"
                            onKeyDown={e => {
                              this.handleDownloadMenu(e);
                            }}
                          >
                            <MenuItem
                              onClick={e => {
                                this.handleDownload(e, 1, 1);
                              }}
                              style={{ fontSize: "10px" }}
                            >
                              Agrupado por mes
                            </MenuItem>
                            <MenuItem
                              onClick={e => {
                                this.handleDownload(e, 0, 1);
                              }}
                              style={{ fontSize: "10px" }}
                            >
                              Sin agrupar
                            </MenuItem>
                            <MenuItem
                              onClick={e => {
                                this.handleDownload(e, 1, 0);
                              }}
                              style={{ fontSize: "10px" }}
                            >
                              Agrupado sin facturas
                            </MenuItem>
                            <MenuItem
                              onClick={e => {
                                this.handleDownload(e, 0, 0);
                              }}
                              style={{ fontSize: "10px" }}
                            >
                              Sin agrupar sin facturas
                            </MenuItem>
                            <MenuItem
                              onClick={e => {
                                this.handleDownloadUserAlert();
                              }}
                              style={{ fontSize: "10px" }}
                            >
                              Mis alertas
                            </MenuItem>
                            <MenuItem
                              onClick={e => {
                                this.handleDownloadVehicleMovement();
                              }}
                              style={{ fontSize: "10px" }}
                            >
                              Movimientos Internos
                            </MenuItem>
                            <MenuItem
                              onClick={e => {
                                this.handleDownloadValets();
                              }}
                              style={{ fontSize: "10px" }}
                            >
                              Valets
                            </MenuItem>
                          </MenuList>
                        </ClickAwayListener>
                      </Paper>
                    </Grow>
                  )}
                </Popper>
              </IconButton>
            </Tooltip>
            <Tooltip title={"Cerradas"}>
              <FormControlLabel
                control={
                  <Switch
                    size="small"
                    onChange={this.handleClosedWorkOrders}
                    value={this.state.closed}
                    checked={this.state.closed}
                  />
                }
                label="Cerradas"
                labelPlacement="bottom"
                className="m-0 mt-3 mx-1"
              />
            </Tooltip>
            <Tooltip title={"Mías"}>
              <FormControlLabel
                control={
                  <Switch
                    size="small"
                    onChange={this.handleMyWorkOrders}
                    value={this.state.mine}
                    checked={this.state.mine}
                  />
                }
                label="Mías"
                labelPlacement="bottom"
                className="m-0 mt-3 mx-1"
              />
            </Tooltip>
            <div className="d-inline-block">
              <Tooltip title={"Nuevas"}>
                <FormControlLabel
                  control={
                    <Switch
                      size="small"
                      onChange={e => {
                        this.handleAutoFilter("work_orders_new", e);
                      }}
                      value={this.state.work_orders_new}
                      checked={this.state.work_orders_new}
                      className="mr-1"
                    />
                  }
                  label="Nuevas"
                  labelPlacement="bottom"
                  className="m-0 mt-3"
                />
              </Tooltip>
              <Tooltip title={"Requieren atención"}>
                <FormControlLabel
                  control={
                    <Switch
                      size="small"
                      onChange={e => {
                        this.handleAutoFilter("attention_required", e);
                      }}
                      value={this.state.attention_required}
                      checked={this.state.attention_required}
                      className="mr-1"
                    />
                  }
                  label="Requieren atención"
                  labelPlacement="bottom"
                  className="m-0 mt-3"
                />
              </Tooltip>
              <Tooltip title={"Esperando Respuesta"}>
                <FormControlLabel
                  control={
                    <Switch
                      size="small"
                      onChange={e => {
                        this.handleAutoFilter("waiting_answer", e);
                      }}
                      value={this.state.waiting_answer}
                      checked={this.state.waiting_answer}
                      className="mr-1"
                    />
                  }
                  label="Esperando Respuesta"
                  labelPlacement="bottom"
                  className="m-0 mt-3"
                />
              </Tooltip>
            </div>
            <Tooltip title={"Turnos"}>
              <IconButton
                onClick={e => {
                  window.location.href = "work-orders/calendar";
                }}
              >
                <EventIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title={"Nuevo"}>
              <IconButton
                onClick={e => {
                  window.location.href = "work-order/0";
                }}
              >
                <AddIcon />
              </IconButton>
            </Tooltip>
          </React.Fragment>
        );
      },
      customToolbarSelect: (selectedRows, displayData, setSelectedRows) => {
        return (
          <React.Fragment>
            <div>
              <Tooltip title={"Asignar"}>
                <IconButton className="mr-4">
                  <GroupAddIcon
                    onClick={e =>
                      this.handleAssignWorkOrders(selectedRows, displayData)
                    }
                  />
                </IconButton>
              </Tooltip>
            </div>
          </React.Fragment>
        );
      },

      /*	      onDownload: (buildHead, buildBody, columns, data) => {
	      	window.location.href="api/ot/download"
	      	return false;
	      },
*/ onTableInit: (
        action,
        tableState
      ) => {
        this.setState({ userConfigTableState: tableState });
      },
      onTableChange: (action, tableState) =>
        this.handleChange(action, tableState),
      enableNestedDataAccess: ".",
      print: false,
      serverSide: this.state.serverSide,
      download: false, //search: false,
      onSearchClose: () => {
        this.getWorkOrders();
      },
      searchOpen: true,
      customSearchRender: (searchText, handleSearch, hideSearch, options) => {
        return (
          <React.Fragment>
            <TextField
              placeholder={"Buscar patente, numero de OT o factura"}
              className={classes.searchText}
              value={searchText || ""}
              onChange={e => {
                handleSearch(e.target.value);
              }}
              fullWidth={true}
              inputRef={el => (this.searchField = el)}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="start">
                    <IconButton
                      className={classes.clearIcon}
                      onClick={(() => handleSearch(""), hideSearch)}
                    >
                      <SearchIcon />
                    </IconButton>
                  </InputAdornment>
                )
              }}
              autoFocus
            />
          </React.Fragment>
        );
      },
      confirmFilters: true,
      filter: true,
      filterType: "checkbox",
      rowsPerPage: this.state.q_rows,
      responsive: "standard",
      draggableColumns: {
        enabled: true,
        transitionTime: 300
      },
      count: this.state.count,
      customFilterDialogFooter: filterList => {
        return (
          <div style={{ marginTop: "40px" }}>
            <Button
              variant="contained"
              onClick={() => {
                this.handleFilterSubmit(filterList);
              }}
            >
              Aplicar
            </Button>
          </div>
        );
      },
      onChangePage: page => {
        //this.setState({loaded: false})
        this.getWorkOrders(this.state.closed, this.state.mine, page + 1);
      },
      onChangeRowsPerPage: numberOfRows => {
        this.setState({ q_rows: numberOfRows });
      },
      onColumnSortChange: (changedColumn, direction) => {
        this.getWorkOrders(this.state.closed, this.state.mine);
      },
      setRowProps: (row, dataIndex, rowIndex) => {
        var layout = row[21];
        if (layout) {
          if (layout.color) {
            return {
              style: { backgroundColor: layout.color }
            };
          }
        }
      },

      textLabels: {
        toolbar: {
          search: "Buscar",
          viewColumns: "Ver columnas",
          filterTable: "Filtros",
          downloadCsv: "Exportar XLS"
        },
        body: {
          noMatch: this.state.loaded ? (
            "No hay resultados"
          ) : (
            <CircularProgress />
          )
        },
        selectedRows: {
          text: "fila(s) seleccionadas"
        },
        viewColumns: {
          title: "Ver columnas"
        },
        pagination: {
          next: "Siguiente",
          previous: "Anteior",
          rowsPerPage: "Cantidad por página:",
          displayRows: "de"
        },
        filter: {
          all: "Todos",
          title: "Filtros",
          reset: "Limpiar"
        }
      }
    };
    return (
      <Container fluid className="main-content-container px-4">
        <Dialog
          open={dialog.open}
          onClose={this.handleAssignWorkOrderDialog}
          fullWidth
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{dialog.title}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {this.state.dialog.message ? (
                this.state.dialog.message
              ) : (
                <TextField
                  id="user_id"
                  name="user_id"
                  select
                  margin="normal"
                  className="mr-2 mt-1"
                  InputLabelProps={{
                    shrink: true
                  }}
                  onChange={this.handleAssignUserChange}
                  value={dialog.user_id}
                  inputProps={{ style: { minWidth: 70, fontSize: "0.75rem" } }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Typography variant="caption" style={{ width: 60 }}>
                          Asignar a:
                        </Typography>
                      </InputAdornment>
                    ),
                    style: { fontSize: "0.75rem" }
                  }}
                >
                  {this.state.users.map(option => (
                    <MenuItem
                      key={option.id}
                      value={option.id}
                      className={classes.menu}
                    >
                      {option.name}
                    </MenuItem>
                  ))}
                </TextField>
              )}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            {this.state.dialog.submit === 0 ? (
              <React.Fragment>
                <Button
                  onClick={this.handleAssignWorkOrderDialog}
                  color="primary"
                  variant="contained"
                >
                  Cancelar
                </Button>
                {this.state.dialog.saving === false ? (
                  <Button
                    onClick={this.handleAssignWorkOrderSubmit}
                    color="primary"
                    autoFocus
                    variant="contained"
                  >
                    Aceptar
                  </Button>
                ) : (
                  ""
                )}
              </React.Fragment>
            ) : (
              <Button
                onClick={this.handleAssignWorkOrderDialog}
                color="primary"
                autoFocus
                variant="contained"
              >
                Aceptar
              </Button>
            )}
          </DialogActions>
        </Dialog>

        <Row noGutters className="page-header pt-2 pb-1">
          <Col className="col col-6">
            <PageTitle sm="4" title="Lista OT" className="text-sm-left" />
          </Col>
          <Col className="col col-6">
            <Fab
              color="primary"
              aria-label="edit"
              variant="extended"
              style={{ boxShadow: "none" }}
              fontSize="small"
              className="MuiButtonBase-root MuiFab-sizeSmall mr-2"
              href={this.handleChartsClose.bind(this)}
            >
              {this.state.display === "" ? (
                <ExpandLess onClick={this.handleChartsClose} />
              ) : (
                <ExpandMore onClick={this.handleChartsOpen} />
              )}
            </Fab>
          </Col>
        </Row>
        {this.state.loaded ? (
          <Row className={this.state.display}>
            <Col className="col col-3 mb-4">
              <Charts title="Por estado" chartData={chartstate} />
            </Col>
            <Col className="col col-3 mb-4">
              <Charts title="Por tipo" chartData={charttype} />
            </Col>
            <Col className="col col-3 mb-4">
              <Charts title="Por Contrato" chartData={chartContract} />
            </Col>
          </Row>
        ) : (
          ""
        )}
        {/*			      	<Col className="col col-3 mb-4">
				    	<Charts title="Asignados a mi" chartData={chartData2} />
				    </Col>
			      	<Col className="col col-3 mb-4">
				    	<Charts title="Por estado" chartData={chartData2} />
				    </Col>
			      	<Col className="col col-3 mb-4">
				    	<Charts title="De esta semana" chartData={chartData2}/>
				    </Col>
				    </Row>
				    */}
        <Row>
          <Col className="p-2">
            {this.state.loaded ? (
              <MuiThemeProvider theme={this.getMuiTheme()}>
                <Backdrop
                  open={this.state.backdrop}
                  onClick={this.handleCloseBackdrop}
                  style={{ zIndex: 10000, color: "#3f51b5" }}
                >
                  <CircularProgress color="inherit" />{" "}
                  <Typography className="ml-2" variant="h5" color="primary">
                    Descargando...
                  </Typography>
                </Backdrop>
                <MUIDataTable
                  data={this.state.work_orders}
                  columns={this.getColumns()}
                  options={options}
                  title={
                    this.state.refreshing && (
                      <CircularProgress color="inherit" />
                    )
                  }
                />
              </MuiThemeProvider>
            ) : (
              <CircularProgress />
            )}
          </Col>
        </Row>
      </Container>
    );
  }
}
export default withStyles(useStyles)(OT);
